import { Tab } from 'bootstrap';
import React from 'react';
import TalTable from './TalTable';

const Blog = () => {
    return (
        <section style={{
            backgroundColor: 'white',
            color: 'black',
            height: '100%',

        }} className=''>
            <h1 className='text-center'>তবলার ইতিহাস</h1>
            <p style={{
                fontSize: '25px'
            }}>
                তবলা শব্দটির <q>তব ভি বোলা</q> থেকে এসেছে। তবলার আদি সূত্র মৃদঙ্গ থেকে। তবলার  আবিষ্কারক হযরত আমির খসরু।
                আগে রাজরানীদের সময়ে বা আরো আগে যখন বাইজি নাচ-গান হতো তখন থেকে এটির(তবলা) এমন রূপ। এই চামড়া কে তবলা বা ডুগির মুখে টানটান করে আটকানো হয় এবং এতে আঙ্গুলের আঘাত দ্বারা বিভিন্ন রকমের শব্দ উৎপন্ন করা হয়। যিনি তবলা বাজান তাকে তবলিয়া বা তবলচি বলা হয়।
            </p>


            {/* ভারতীয় সংগীতের তবলার পরিচিত */}


            <h1 className='text-center'>ভারতীয় সংগীতের তবলার পরিচিতি</h1>
            <p style={{
                fontSize: '25px'
            }}>
                <span>
                    ভারতের শাস্ত্রীয় সংগীতে তবলার কয়েকটি ঘরানা আছে। যেখানে বিশেষ পদ্ধতি অনুসরণে তবলার অনুশীলন করা হয়। ঘরানাগুলো নিচে দেওয়া হল -
                </span>


                <ol style={{
                    display: 'flex',
                    justifyContent: 'space-around'
                }}>
                    <div>
                        <li>লাক্ষৌ ঘরানা</li>
                        <li>দিল্লি ঘরানা</li>
                        <li>ফাহরুখাবাদ ঘারানা</li>
                    </div>
                    <div>
                        <li>আজরাড়া ঘরানা </li>
                        <li>বেনারস  ঘরানা</li>
                        <li>এলাহাবাদ ঘরানা</li>
                    </div>
                </ol>
                <span>
                    শাস্ত্রীয় সংগীতের এমন অনেক বিশিষ্ট তবলিয়া আছেন যাদের অবদানে সঙ্গীতে তালের ব্যবহারের এত অগ্রগতি। বিশিষ্ট কয়েকজনের নাম এবং ঘরানার প্রতিষ্ঠাতা দের নাম নিম্নে দেওয়া হল -
                </span>
                <ul style={{
                    marginLeft: '100px'
                }}>
                    <li>
                        <a target="_blank" href="https://ragatip.com/pandit-ram-sahai-fountainhead-of-the-benares-tabla-gharana/">পণ্ডিত রামসহায়(বেনারস ঘারনার প্রতিষ্ঠাতা)</a>
                    </li>
                    <li>
                        <a target="_blank" href="">হাজী বেলায়েত খান(ফারুখাবাদ ঘারনার প্রতিষ্ঠাতা)</a>
                    </li>
                    <li>
                        <a target="_blank" href="https://en.wikipedia.org/wiki/Kishan_Maharaj">ওস্তাদ আহাম্মাদজান থেরকুয়া(ফারুখাবাদ ঘরানা)</a>
                    </li>
                    <li>
                        <a target="_blank" href="https://en.wikipedia.org/wiki/Alla_Rakha">ওস্তাদ আল্লারাখা (পাঞ্জাব ঘরানা)</a>
                    </li>
                    <li>
                        <a target="_blank" href="https://en.wikipedia.org/wiki/Zakir_Hussain_(musician)">জাকির হোসেন(পাঞ্জাব ঘরানা)</a>
                    </li>
                </ul>
            </p>

            {/*----------------- বাংলাদেশের তবলা পরিচিতি---------------- */}


            <h1 className='text-center'>বাংলাদেশের তবলা পরিচিতি</h1>
            <p style={{
                fontSize: '25px'
            }}>বাংলায় তবলার ঐতিহ্য সাম্প্রতিক সময়ের বাংলায় তবলাকে পরিচিত করিয়েছেন জনপ্রকাশ ঘোষ ও হিরু গাঙ্গুলী। বাংলার কয়েকজন বিশিষ্ট তবলীয়া হলেন -
                <ul style={{
                    marginLeft: '100px'
                }}>
                    <li>
                        <a target="_blank" href="https://en.wikipedia.org/wiki/Shankar_Ghosh">শঙ্কর ঘোষ</a>
                    </li>
                    <li>
                        <a target="_blank" href="https://en.wikipedia.org/wiki/Kumar_Boses">পন্ডিত কুমার বোস</a>
                    </li>
                    <li>
                        <a target="_blank" href="https://en.wikipedia.org/wiki/Anindo_Chatterjee">অনিন্দ্য চট্টোপাধ্যায়</a>
                    </li>
                    <li>
                        <a target="_blank" href="https://en.wikipedia.org/wiki/Bickram_Ghosh">বিক্রম ঘোষ</a>
                    </li>
                </ul>
            </p>



            {/*------------ তবলার তালের পরিচিতি -----------*/}

            <h1 className='text-center'>তবলার তালের পরিচিতি</h1>

            <p style={{
                fontSize: '25px'
            }}>
                পৃথিবীতে হাজার প্রকারের তাল আছে। তবে ক্লাসিকাল মিউজিকে ত্রিতাল, ঝাঁপটাল, তেওরা, কাহারবা ও দাদরা এগুলোই অধিক ব্যবহৃত হয়। বাংলা আধুনিক মিউজিকে কাহারবা ও দাদরা অধিক ব্যবহৃত হয়,
                তবে তেওরা, ঝাঁপতাল একটু কম ব্যবহৃত হয়।
            </p>
            <p style={{
                fontSize: '25px'
            }}>
                রবীন্দ্রনাথের তৈরি কিছু তাল তার বিশেষ কিছু গানে নির্দিষ্টভাবে ব্যবহৃত হয়। তবে ব্যান্ড মিউজিকে সাধারণত কাহারবা (8 bit) ও দাদরা (6 bit) এ দুটোই অধিক ব্যবহৃত হয়। এদের মধ্যে কাহারবা ও দাদরার অনেক ফ্লেভার বা ঢং রয়েছে। যা বিভিন্ন মিউজিক-এ তাল-লয় ঠিক রেখে বাজানো হয়।
            </p>


            {/*---------------- তালের তালিকা -----------------*/}

            <h1>তালের তালিকা</h1>
            <ol style={{
                display: 'flex',
                justifyContent: 'space-around',
                fontSize: '25px'
            }}>
                <div>
                    <li>ত্রিতাল</li>
                    <li>দাদরা</li>
                    <li>ঝাঁপতাল</li>
                    <li>দেওয়া</li>
                    <li>রূপক</li>
                    <li>ঝম্পক</li>
                    <li>একতল</li>
                    <li>পঞ্চম সাওয়ারি</li>
                </div>
                <div>
                    <li>মাঠ</li>
                    <li>চারতল</li>
                    <li>যাইটাল</li>
                    <li>বিপদী</li>
                    <li>ঝুমুর</li>
                    <li>আধা চৌতাল</li>
                    <li>ধামার</li>

                </div>
            </ol>
            <TalTable></TalTable>
        </section>
    );
};

export default Blog;




/* 

 <section>
                <h4>Why are we using firebase ?</h4>
                <p>We use firebase for implement authentication system in our projects. we can can also host free our project on firebase. it also give us database system. firebase alo provide google analytics.</p>
                <h6>Alternative of firebase ?</h6>
                <li>Back4app</li>
                <li>Parse</li>
                <li>App write</li>
                <li>Deployd</li>
                <li>Nhost</li>
            </section>
            <section>
                <h2>Difference between authentication and authorization</h2>
                <p>Authentication is the process of recognizing a user's identity. It is the mechanism of associating an incoming request with a set of identifying credentials.</p>
                <p>uthorization is a security mechanism to determine access levels or user/client privileges related to system resources including files, services, computer programs, data and application features.</p>
            </section>
            <section>
                <h3>What other service firebase provide?</h3>
                <li>Realtime Database</li>
                <li>File store</li>
                <li>Storage</li>
                <li>Hosting</li>
                <li>Cloud function</li>
                <li>Security rules</li>
                <li>Emulator suite</li>
            </section>
*/